import React, { useEffect, useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import Header from "../components/Header";
import { useAuth } from "../context/AuthContext";
import { minhasEntrevistas, escolherHorarioEntrevista, pedirOutrosHorarios, cancelarEntrevista, candidaturasDaEmpresa, minhasAulas,
  obterPerfilPublico, obterVaga, arquivoParaVer, empresaLogoUrl, anotacoesEntrevista, salvarAnotacoesEntrevista } from "../services/api";
import AgendarEntrevista, { STATUS_ENTREVISTA, SituacaoEntrevista } from "../components/AgendarEntrevista";
import AgendaSemana, { itensDeEntrevistas, itensDeAulas } from "../components/AgendaSemana";
import { abrirSala } from "../services/abrirSala";
import SimularEntrevista from "../components/SimularEntrevista";

// 📅 MINHAS ENTREVISTAS (17/10/2026): candidato escolhe o horário, entra na sala, pede outros horários ou cancela;
// a empresa vê todas as entrevistas das vagas dela.
const quando = (iso) => new Date(iso).toLocaleString("pt-BR", { weekday: "long", day: "2-digit", month: "2-digit", hour: "2-digit", minute: "2-digit" });

// 18/10/2026 (Nelson: "isso ficou feio, não tem como abrir um modal com datas e horários?"): no lugar do prompt do
// navegador, o candidato sugere até 3 datas/horários + recado. A empresa vê no cartão e aceita uma sugestão com um clique.
function PedirOutros({ entrevista, fechar, enviar }) {
  const [sugestoes, setSugestoes] = useState(["", "", ""]);
  const [recado, setRecado] = useState("");
  const minimo = new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().slice(0, 16);
  const preenchidas = sugestoes.filter(Boolean);
  const mandar = () => enviar(recado.trim(), preenchidas.map((s) => new Date(s).toISOString()));
  return (
    <div className="fixed inset-0 z-[60] bg-black/40 flex items-center justify-center p-4" onClick={fechar}>
      <div className="bg-white rounded-2xl shadow-2xl w-full max-w-md p-5" onClick={(e) => e.stopPropagation()}>
        <h2 className="text-lg font-bold text-gray-900">Pedir outros horários</h2>
        <p className="text-sm text-gray-500 mt-1">Nenhum horário de {entrevista.empresa || "a empresa"} serve? Sugira quando você pode. A empresa recebe o aviso e propõe de novo.</p>
        <div className="space-y-2 mt-4">
          {sugestoes.map((s, i) => (
            <label key={i} className="block text-sm">
              <span className="text-gray-600">Opção {i + 1}{i > 0 && " (opcional)"}</span>
              <input type="datetime-local" min={minimo} value={s}
                onChange={(e) => setSugestoes((v) => v.map((x, j) => (j === i ? e.target.value : x)))}
                className="mt-1 w-full rounded-lg border border-gray-300 px-3 py-2" />
            </label>
          ))}
          <label className="block text-sm">
            <span className="text-gray-600">Recado (opcional)</span>
            <textarea value={recado} onChange={(e) => setRecado(e.target.value)} rows={2} maxLength={300}
              placeholder="Ex.: prefiro à tarde, depois das 14h" className="mt-1 w-full rounded-lg border border-gray-300 px-3 py-2" />
          </label>
        </div>
        <div className="flex justify-end gap-2 mt-5">
          <button onClick={fechar} className="rounded-lg px-4 py-2 text-sm font-semibold text-gray-600 hover:bg-gray-100">Cancelar</button>
          <button onClick={mandar} disabled={!preenchidas.length && !recado.trim()}
            className="rounded-lg bg-accent hover:opacity-90 disabled:opacity-40 text-white text-sm font-semibold px-4 py-2">Enviar à empresa</button>
        </div>
      </div>
    </div>
  );
}

// 18/10/2026 (Nelson: "onde a empresa busca o candidato para chamar para entrevista?"): no próprio menu Entrevistas,
// a empresa escolhe a vaga (ou busca pelo nome) e chama quantos candidatos quiser, cada um com o seu agendamento.
const ATIVAS = ["proposta", "confirmada"];
const semAcento = (s) => (s || "").normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();
// 🧭 PARA SE PREPARAR (18/10/2026, Nelson): no modal da agenda, a empresa vê um resumo do candidato e abre o currículo;
// o candidato vê um resumo da vaga e abre o próprio currículo, para ensaiar as respostas.
// Tempo de experiência aproximado a partir dos períodos do currículo ("2019 - 2022", "mar/2021 - atual").
// Soma os anos de cada experiência sem contar duas vezes o mesmo ano (trabalhos ao mesmo tempo).
const tempoExperiencia = (exps) => {
  const anos = new Set();
  const atual = new Date().getFullYear();
  (exps || []).forEach((x) => {
    const p = (x.periodo || "").toLowerCase();
    const ys = (p.match(/(19|20)\d\d/g) || []).map(Number);
    if (!ys.length) return;
    const ini = Math.min(...ys);
    const fim = /atual|hoje|presente|o momento/.test(p) ? atual : Math.max(...ys);
    for (let a = ini; a < Math.max(fim, ini + 1); a++) anos.add(a);
  });
  return anos.size;
};
const haDias = (d) => { const n = Math.floor((Date.now() - new Date(d)) / 86400000); return n <= 0 ? "hoje" : n === 1 ? "há 1 dia" : `há ${n} dias`; };
const Linha = ({ rot, children }) => children ? <div className="text-xs mt-1"><span className="text-gray-500">{rot}:</span> {children}</div> : null;
const dinheiro = (v) => v == null ? null : Number(v).toLocaleString("pt-BR", { style: "currency", currency: "BRL", maximumFractionDigits: 0 });
// 📝 18/10/2026 (Nelson: "uma aba anotações, já vi entrevistadores anotarem por conta própria" e "essas anotações precisam
// ir para o e-mail no final junto com a análise da IA"). Privadas, salvam sozinhas enquanto digita.
function Anotacoes({ entrevistaId, ehEmpresa }) {
  const [texto, setTexto] = useState(null);
  const [salvoEm, setSalvoEm] = useState(null);
  const [estado, setEstado] = useState("");
  const timer = React.useRef(null);
  useEffect(() => {
    anotacoesEntrevista(entrevistaId).then((r) => { setTexto(r.texto || ""); setSalvoEm(r.atualizadoEm); }).catch(() => setTexto(""));
    return () => clearTimeout(timer.current);
  }, [entrevistaId]);
  const mudar = (v) => {
    setTexto(v); setEstado("digitando");
    clearTimeout(timer.current);
    timer.current = setTimeout(() => {
      setEstado("salvando");
      salvarAnotacoesEntrevista(entrevistaId, v).then((r) => { setSalvoEm(r.atualizadoEm); setEstado("salvo"); }).catch(() => setEstado("erro"));
    }, 900);
  };
  if (texto === null) return <p className="text-xs text-gray-400 mt-3">Carregando…</p>;
  const dica = ehEmpresa
    ? "Ex.: pontos fortes, dúvidas sobre a experiência, o que perguntar, próximos passos combinados."
    : "Ex.: perguntas que quero fazer, exemplos que quero contar, o que combinamos, salário e benefícios.";
  return (
    <div className="mt-3">
      <p className="text-xs text-gray-500">🔒 Só você vê. No fim da entrevista, elas vão para o seu e-mail{" "}
        junto com a análise da IA, se você pediu o feedback.</p>
      <textarea value={texto} onChange={(ev) => mudar(ev.target.value)} rows={12} maxLength={20000} placeholder={dica}
        className="mt-2 w-full rounded-xl border border-gray-300 px-3 py-2 text-sm leading-relaxed focus:outline-none focus:ring-2 focus:ring-primary/40" />
      <div className="text-[11px] text-gray-400 mt-1">
        {estado === "salvando" ? "Salvando…" : estado === "erro" ? <span className="text-red-600">Não salvou. Confira a internet.</span>
          : salvoEm ? `Salvo às ${new Date(salvoEm).toLocaleTimeString("pt-BR", { hour: "2-digit", minute: "2-digit" })}` : "Salva sozinho enquanto você digita."}
      </div>
    </div>
  );
}

function VerCurriculo({ caminhos }) {
  // caminhos: [{ k, rotulo, caminho }] — o 1º abre sozinho; os outros viram botões para trocar
  const [atual, setAtual] = useState(caminhos[0]?.k);
  const [doc, setDoc] = useState(null);
  const [erro, setErro] = useState("");
  useEffect(() => {
    const c = caminhos.find((x) => x.k === atual);
    if (!c) return undefined;
    let vivo = true, url = null;
    setDoc(null); setErro("");
    arquivoParaVer(c.caminho).then((d) => { url = d.url; if (vivo) setDoc(d); else URL.revokeObjectURL(d.url); }).catch((er) => vivo && setErro(er.message));
    return () => { vivo = false; if (url) URL.revokeObjectURL(url); };
  }, [atual]); // eslint-disable-line react-hooks/exhaustive-deps
  const botao = "rounded-lg border border-primary/40 px-3 py-1.5 text-xs font-semibold text-primary hover:bg-primary/5";
  return (
    <div className="mt-3">
      <div className="flex flex-wrap items-center gap-2">
        {caminhos.length > 1 && caminhos.map((c) => (
          <button key={c.k} onClick={() => setAtual(c.k)}
            className={"rounded-full px-3 py-1 text-xs font-semibold border " + (atual === c.k ? "bg-primary text-white border-primary" : "bg-white text-gray-600 border-gray-200")}>{c.rotulo}</button>
        ))}
        {doc && <button className={botao + " ml-auto"} onClick={() => window.open(doc.url, "_blank")}>↗ Abrir em nova aba</button>}
        {doc && <a className={botao} href={doc.url} download={doc.nome}>⬇ Baixar</a>}
      </div>
      {erro && <p className="text-xs text-red-600 mt-2">{erro}</p>}
      {!doc && !erro && <p className="text-xs text-gray-400 mt-3">Carregando o currículo…</p>}
      {doc && doc.pdf && <iframe title="Currículo" src={doc.url + "#toolbar=0&navpanes=0&scrollbar=1&view=FitH"} className="w-full h-[58vh] mt-2 rounded-lg border border-gray-200 bg-white" />}
      {doc && !doc.pdf && <p className="text-xs text-gray-600 mt-3">Este arquivo não é PDF ({doc.nome}), então o navegador não consegue mostrar aqui. Use <b>Baixar</b> para abrir no seu computador.</p>}
    </div>
  );
}

export function Preparacao({ e, ehEmpresa }) {
  const [info, setInfo] = useState(null);
  const [erro, setErro] = useState("");
  const [extra, setExtra] = useState(null);   // empresa: a vaga (comparar pretensão) · candidato: a empresa (reputação)
  const [aba, setAba] = useState("resumo");   // "resumo" | "curriculo"
  useEffect(() => {
    setInfo(null); setExtra(null);
    (ehEmpresa ? obterPerfilPublico(e.candidatoId) : obterVaga(e.vagaId)).then(setInfo).catch((er) => setErro(er.message));
    if (ehEmpresa) obterVaga(e.vagaId).then(setExtra).catch(() => {});
  }, [e.candidatoId, e.vagaId, ehEmpresa]);
  const quemEntrevista = [e.entrevistador, ...(e.outros || [])].filter(Boolean).join(", ");
  const botao = "rounded-lg border border-primary/40 px-3 py-1.5 text-xs font-semibold text-primary hover:bg-primary/5 disabled:opacity-50";
  if (erro && !info) return <p className="mt-4 text-xs text-gray-400">Resumo indisponível: {erro}</p>;
  if (!info) return <p className="mt-4 text-xs text-gray-400">Carregando o resumo…</p>;
  const chips = (lista) => (lista || []).slice(0, 10).map((s) => (
    <span key={typeof s === "string" ? s : s.nome} className="rounded-full bg-slate-100 px-2 py-0.5 text-[11px]">{typeof s === "string" ? s : s.nome}</span>));

  const abas = (
    <div className="flex flex-wrap gap-1 mt-4 border-b border-gray-200 sticky z-10 bg-white" style={{ top: "var(--topo, 0px)" }}>
      {(ehEmpresa ? [["resumo", "👤 Resumo do candidato"], ["curriculo", "📄 Currículo"], ["notas", "📝 Anotações"]]
        : [["resumo", "🧭 Para se preparar"], ["vaga", "💼 A vaga"], ["empresa", "🏢 A empresa"], ["curriculo", "📄 Meu currículo"], ["notas", "📝 Anotações"]]).map(([k, txt]) => (
        <button key={k} onClick={() => setAba(k)}
          className={"px-3 py-1.5 text-xs font-semibold rounded-t-lg -mb-px " + (aba === k ? "bg-white border border-gray-200 border-b-white text-primary" : "text-gray-500 hover:text-gray-800")}>{txt}</button>
      ))}
    </div>
  );
  if (aba === "notas") return <>{abas}<Anotacoes entrevistaId={e.id} ehEmpresa={ehEmpresa} /></>;
  if (aba === "curriculo") {
    const caminhos = ehEmpresa
      ? [{ k: "p", rotulo: "Padrão eaiRH", caminho: `/perfil/curriculo-gerado/${e.candidatoId}` },
         ...(info.temCurriculo ? [{ k: "a", rotulo: "Arquivo enviado pelo candidato", caminho: `/perfil/curriculo/${e.candidatoId}` }] : [])]
      : [{ k: "g", rotulo: "Meu currículo", caminho: "/perfil/curriculo-gerado" }];
    return <>{abas}<VerCurriculo caminhos={caminhos} /></>;
  }

  // 18/10/2026 (Nelson: "o ver vaga saiu da tela da entrevista, seria interessante ser uma aba no modal")
  if (aba === "vaga" && !ehEmpresa) {
    const v = info;
    const faixa = v.salarioMin || v.salarioMax ? [dinheiro(v.salarioMin), dinheiro(v.salarioMax)].filter(Boolean).join(" a ") : null;
    return (<>{abas}
      <div className="mt-3 text-sm">
        <div className="font-bold text-text text-base">{v.titulo}</div>
        <div className="text-gray-600">{v.empresa}</div>
        <div className="text-xs text-gray-500 mt-1">{[v.cidade, v.remoto ? "remoto" : v.modalidade, v.tipoContratacao, v.senioridade, v.areaAtuacao].filter(Boolean).join(" · ")}</div>
        <Linha rot="Salário">{faixa}</Linha>
        <Linha rot="Benefícios">{(v.beneficios || []).length > 0 && v.beneficios.join(", ")}</Linha>
        <Linha rot="Prazo de retorno informado pela empresa">{v.respostaPrazoDias && `${v.respostaPrazoDias} dias`}</Linha>
        {(v.skills || []).length > 0 && <div className="flex flex-wrap gap-1 mt-2">{chips(v.skills)}</div>}
        {v.descricao && <p className="text-sm text-gray-700 whitespace-pre-line mt-3 leading-relaxed">{v.descricao}</p>}
        {v.urlExterna && <a href={v.urlExterna} target="_blank" rel="noreferrer" className="inline-block mt-3 text-xs text-primary font-semibold">Ver a vaga no site da empresa ↗</a>}
      </div>
    </>);
  }

  // 18/10/2026 (Nelson: "a aba empresa deveria trazer informações da empresa, nada de relatos — o candidato conhecer a
  // empresa para se preparar; site, LinkedIn etc."). Nunca sai do modal: os links abrem em nova aba.
  if (aba === "empresa" && !ehEmpresa) {
    const emp = e.empresaInfo || {};
    const links = [["🌐 Site oficial", emp.site], ["LinkedIn", emp.linkedinUrl], ["Instagram", emp.instagram], ["Página de vagas / carreiras", emp.carreiras]].filter(([, u]) => u);
    return (<>{abas}
      <div className="mt-3 text-sm">
        <div className="flex items-center gap-3">
          {emp.temLogo && e.vagaEmpresaId && <img src={empresaLogoUrl(e.vagaEmpresaId)} alt="" className="h-12 w-12 rounded-xl object-contain border border-gray-100 bg-white" />}
          <div>
            <div className="font-bold text-text text-base">{emp.nome}</div>
            <div className="text-xs text-gray-500">{[emp.setor, emp.porte, emp.cidade].filter(Boolean).join(" · ")}</div>
          </div>
        </div>
        {emp.sobre ? <p className="text-sm text-gray-700 whitespace-pre-line mt-3 leading-relaxed">{emp.sobre}</p>
          : emp.sobreSite ? (
            <div className="mt-3">
              <p className="text-sm text-gray-700 whitespace-pre-line leading-relaxed">{emp.sobreSite}</p>
              <p className="text-[11px] text-gray-400 mt-1">Texto do site da empresa.</p>
            </div>
          ) : <p className="text-xs text-gray-500 mt-3">A empresa ainda não escreveu uma apresentação. Vale pesquisar o site e o LinkedIn dela antes da entrevista.</p>}
        <Linha rot="Unidades">{emp.unidades}</Linha>
        <Linha rot="Certificações">{emp.certificacoes}</Linha>
        <Linha rot="Vagas abertas no eaiRH">{emp.vagasAbertas > 0 && `${emp.vagasAbertas}`}</Linha>
        {links.length > 0 && (
          <div className="flex flex-wrap gap-2 mt-3">
            {links.map(([r, u]) => <a key={r} href={u} target="_blank" rel="noreferrer"
              className="rounded-lg border border-primary/40 px-3 py-1.5 text-xs font-semibold text-primary hover:bg-primary/5">{r} ↗</a>)}
          </div>
        )}
        <a href={"https://www.google.com/search?q=" + encodeURIComponent((emp.nome || "") + " empresa")} target="_blank" rel="noreferrer"
          className="inline-block mt-3 text-[11px] text-primary font-semibold">Pesquisar a empresa no Google ↗</a>
        <p className="text-[11px] text-gray-500 mt-3">Dica: conheça o que a empresa faz, os produtos ou clientes e as notícias recentes. Mostrar que pesquisou faz diferença na entrevista.</p>
      </div>
    </>);
  }

  if (ehEmpresa) {
    const p = info;
    const ultima = (p.experiencias || [])[0];
    return (<>{abas}
      {/* 18/10/2026 (Nelson: "aba de resumo do candidato com nome, localização, faixa salarial, tempo de experiência").
          Idade NÃO entra: usar idade na seleção é discriminação (Lei 9.029/95; CLT art. 373-A). */}
      {(() => {
        const anos = tempoExperiencia(p.experiencias);
        const ficha = [
          ["Nome", p.nome],
          ["Localização", [p.cidade, p.aceitaMudarDeCidade && "aceita mudar"].filter(Boolean).join(" · ")],
          ["Pretensão", [p.pretensaoClt && `CLT ${dinheiro(p.pretensaoClt)}`, p.pretensaoPj && `PJ ${dinheiro(p.pretensaoPj)}`].filter(Boolean).join(" · ")],
          ["Faixa da vaga", extra && (extra.salarioMin || extra.salarioMax) ? [dinheiro(extra.salarioMin), dinheiro(extra.salarioMax)].filter(Boolean).join(" a ") : ""],
          ["Experiência", anos ? `≈ ${anos} ano${anos > 1 ? "s" : ""} · ${(p.experiencias || []).length} empresa(s)` : (p.experiencias || []).length ? `${p.experiencias.length} experiência(s)` : ""],
          ["Senioridade", p.senioridade],
          ["Escolaridade", p.escolaridade],
          ["Área", p.areaAtuacao],
          ["Disponibilidade", p.disponibilidadeTexto],
          ["Modalidade", (p.modalidadesAceitas || []).join(", ")],
          ["Contratação", (p.contratacoesAceitas || []).join(", ")],
          ["Candidatou-se", e.candidaturaEm ? `${new Date(e.candidaturaEm).toLocaleDateString("pt-BR")} (${haDias(e.candidaturaEm)})` : ""],
        ].filter(([, v]) => v);
        return (
          <div className="mt-3 grid grid-cols-2 sm:grid-cols-3 gap-2">
            {ficha.map(([r, v]) => (
              <div key={r} className="rounded-xl bg-slate-50 px-2.5 py-2">
                <div className="text-[11px] text-gray-500">{r}</div>
                <div className="text-sm font-semibold text-text leading-snug">{v}</div>
              </div>
            ))}
          </div>
        );
      })()}
      <div className="mt-3 rounded-xl border border-blue-100 bg-blue-50/40 p-3">
        <div className="font-semibold text-text">Quem é {p.nome?.split(" ")[0]}</div>
        {p.headline && <div className="text-gray-700 mt-1">{p.headline}</div>}
        <div className="text-xs text-gray-500 mt-0.5">{[p.areaAtuacao, p.senioridade, p.cidade, p.disponibilidadeTexto].filter(Boolean).join(" · ")}</div>
        {p.resumo && <p className="text-xs text-gray-700 mt-2 line-clamp-4">{p.resumo}</p>}
        {ultima && <div className="text-xs mt-2"><b>Última experiência:</b> {[ultima.cargo, ultima.empresa, ultima.periodo].filter(Boolean).join(" · ")}</div>}
        {(p.experiencias || []).length > 1 && <div className="text-[11px] text-gray-500">+{p.experiencias.length - 1} experiência(s) no currículo</div>}
        {(p.skills || []).length > 0 && <div className="flex flex-wrap gap-1 mt-2">{chips(p.skills)}</div>}
        <div className="mt-2 border-t border-blue-100 pt-2">
          <Linha rot="Recado na candidatura">{e.candidaturaMensagem && <i>“{e.candidaturaMensagem}”</i>}</Linha>
          <Linha rot="Aceita">{[(p.modalidadesAceitas || []).join("/"), (p.contratacoesAceitas || []).join("/"), (p.turnosAceitos || []).join("/")].filter(Boolean).join(" · ")}</Linha>
          <Linha rot="Mobilidade">{[p.aceitaMudarDeCidade && "aceita mudar de cidade", p.cnh && `CNH ${p.cnh}`, p.veiculoProprio && "veículo próprio"].filter(Boolean).join(" · ")}</Linha>
          <Linha rot="Formação">{(p.formacoes || [])[0] && [p.formacoes[0].curso, p.formacoes[0].instituicao].filter(Boolean).join(" · ")}</Linha>
          <Linha rot="Também entrevistam">{(e.outros || []).join(", ")}</Linha>
        </div>
        {p.linkedinUrl && <a href={p.linkedinUrl} target="_blank" rel="noreferrer" className={botao + " inline-block mt-3"}>LinkedIn ↗</a>}
      </div>
    </>);
  }

  const v = info;
  const salario = v.salarioMin || v.salarioMax ? [dinheiro(v.salarioMin), dinheiro(v.salarioMax)].filter(Boolean).join(" a ") : null;
  return (<>{abas}
    <div className="mt-3 rounded-xl border border-blue-100 bg-blue-50/40 p-3">
      <div className="font-semibold text-text">A vaga</div>
      <div className="text-gray-700 mt-1"><b>{v.titulo}</b> · {v.empresa}</div>
      <div className="text-xs text-gray-500 mt-0.5">{[v.cidade, v.remoto ? "remoto" : v.modalidade, v.tipoContratacao, v.senioridade, salario].filter(Boolean).join(" · ")}</div>
      {(v.skills || []).length > 0 && <div className="flex flex-wrap gap-1 mt-2">{chips(v.skills)}</div>}
      <div className="mt-2 border-t border-blue-100 pt-2">
        <Linha rot="Quem vai te entrevistar">{quemEntrevista}</Linha>
        <Linha rot="Você se candidatou">{e.candidaturaEm && `${new Date(e.candidaturaEm).toLocaleDateString("pt-BR")} (${haDias(e.candidaturaEm)})`}</Linha>
        <Linha rot="Duração prevista">{e.duracaoMin && `${e.duracaoMin} minutos`}</Linha>
        <Linha rot="Benefícios">{(v.beneficios || []).length > 0 && v.beneficios.slice(0, 8).join(", ")}</Linha>
      </div>
      {e.empresaInfo && (
        <div className="mt-2 border-t border-blue-100 pt-2">
          <div className="text-xs font-semibold text-text">A empresa: {e.empresaInfo.nome}</div>
          <Linha rot="Setor">{[e.empresaInfo.setor, e.empresaInfo.porte, e.empresaInfo.cidade].filter(Boolean).join(" · ")}</Linha>
          {e.empresaInfo.sobre && <p className="text-xs text-gray-700 mt-1 line-clamp-2">{e.empresaInfo.sobre}</p>}
          <button onClick={() => setAba("empresa")} className="text-[11px] text-primary font-semibold">Conhecer a empresa</button>
        </div>
      )}
      <p className="text-[11px] text-gray-500 mt-2">Dica: releia seu currículo e prepare um exemplo real (situação, o que você fez, resultado) para cada requisito da vaga.</p>
    </div>
  </>);
}

// 📋 18/10/2026 (Nelson: "esses dados do modal precisam estar na tela da entrevista durante a chamada, um botão para
// abrir e fechar"). A sala usa este painel: mesmas abas do modal (resumo, currículo, anotações...).
export function PainelEntrevista({ entrevistaId }) {
  const [dados, setDados] = useState(null);
  const [erro, setErro] = useState("");
  useEffect(() => { minhasEntrevistas().then(setDados).catch((er) => setErro(er.message)); }, [entrevistaId]);
  if (erro) return <p className="text-xs text-red-600">{erro}</p>;
  if (!dados) return <p className="text-xs text-gray-400">Carregando…</p>;
  const e = (dados.entrevistas || []).find((x) => x.id === entrevistaId);
  if (!e) return <p className="text-xs text-gray-500">Entrevista não encontrada para esta conta.</p>;
  return (
    <div className="text-sm">
      <div className="font-bold text-text">{e.vaga}</div>
      <div className="text-xs text-gray-500">{dados.ehEmpresa ? e.candidato : e.empresa}</div>
      <Preparacao e={e} ehEmpresa={dados.ehEmpresa} />
    </div>
  );
}

// Campo que vai sugerindo enquanto digita (qualquer parte do texto: "silva" acha "José da Silva"). Clicar escolhe.
function CampoBusca({ opcoes, valor, escolher, placeholder }) {
  const [texto, setTexto] = useState("");
  const [aberto, setAberto] = useState(false);
  const termo = semAcento(texto.trim());
  const achados = (termo ? opcoes.filter((o) => semAcento(o.rotulo).includes(termo)) : opcoes).slice(0, 30);
  const atual = opcoes.find((o) => o.id === valor);
  return (
    <div className="relative mt-3">
      <input value={aberto ? texto : (atual ? atual.rotulo : texto)} placeholder={placeholder}
        onFocus={() => { setAberto(true); setTexto(""); }}
        onChange={(e) => { setTexto(e.target.value); setAberto(true); }}
        onBlur={() => setTimeout(() => setAberto(false), 150)}
        className="w-full rounded-lg border border-gray-300 px-3 py-2 text-sm" />
      {aberto && (
        <div className="absolute z-20 left-0 right-0 mt-1 max-h-64 overflow-auto rounded-xl border border-gray-200 bg-white shadow-lg">
          {achados.length === 0 && <div className="px-3 py-2 text-sm text-gray-400">Nada encontrado.</div>}
          {achados.map((o) => (
            <button key={o.id} type="button" onMouseDown={(e) => e.preventDefault()}
              onClick={() => { escolher(o.id); setTexto(""); setAberto(false); }}
              className={"block w-full text-left px-3 py-2 text-sm hover:bg-orange-50 " + (o.id === valor ? "bg-orange-50 font-semibold" : "")}>
              {o.rotulo}{o.detalhe && <span className="text-xs text-gray-400"> · {o.detalhe}</span>}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}

function ChamarParaEntrevista({ entrevistas, abrir }) {
  const [cands, setCands] = useState(null);
  const [modo, setModo] = useState("vaga");   // "vaga" → escolhe a vaga e vê os candidatos · "candidato" → escolhe a pessoa e vê as vagas dela
  const [vaga, setVaga] = useState(null);
  const [pessoa, setPessoa] = useState(null);
  useEffect(() => { candidaturasDaEmpresa().then((r) => setCands(r.candidaturas || [])).catch(() => setCands([])); }, []);
  if (!cands) return null;
  const ativas = cands.filter((c) => c.vagaAtiva);
  const conta = (lista, chave, id) => lista.filter((c) => c[chave] === id).length;
  const opVagas = [...new Map(ativas.map((c) => [c.vagaId, c.vaga])).entries()]
    .map(([id, titulo]) => ({ id, rotulo: titulo, detalhe: `${conta(ativas, "vagaId", id)} candidato(s)` }));
  const opPessoas = [...new Map(ativas.map((c) => [c.usuarioId, c.nome])).entries()]
    .map(([id, nome]) => ({ id, rotulo: nome, detalhe: `${conta(ativas, "usuarioId", id)} vaga(s)` }))
    .sort((a, b) => a.rotulo.localeCompare(b.rotulo, "pt-BR"));
  const daPessoa = (c) => entrevistas.find((e) => e.vagaId === c.vagaId && e.candidatoId === c.usuarioId && ATIVAS.includes(e.status));
  const dia = (d) => new Date(d).toLocaleDateString("pt-BR");
  const Acao = ({ c }) => {
    const e = daPessoa(c);
    if (e) {
      const st = STATUS_ENTREVISTA[e.status] || { txt: e.status, cls: "bg-slate-100" };
      return <span className={"rounded-full px-2 py-0.5 text-xs font-semibold " + st.cls}>{st.txt}</span>;
    }
    return <button onClick={() => abrir({ vagaId: c.vagaId, candidato: { usuarioId: c.usuarioId, nome: c.nome }, remarcar: false })}
      className="rounded-lg bg-accent hover:opacity-90 text-white text-xs font-semibold px-3 py-1.5">📅 Agendar</button>;
  };
  const aba = (k, txt) => (
    <button onClick={() => setModo(k)}
      className={"px-3 py-1.5 text-sm font-semibold rounded-lg " + (modo === k ? "bg-primary text-white" : "text-gray-600 hover:bg-gray-100")}>{txt}</button>
  );
  const linhas = modo === "vaga" ? ativas.filter((c) => c.vagaId === vaga) : ativas.filter((c) => c.usuarioId === pessoa);
  return (
    <section className="mt-6 bg-white rounded-2xl shadow-sm p-5">
      <h2 className="font-bold text-text">📅 Chamar para entrevista</h2>
      <div className="flex items-center gap-1 mt-3 rounded-xl bg-gray-50 p-1 w-fit">
        <span className="text-xs text-gray-500 px-2">Buscar por:</span>
        {aba("vaga", "Vaga")}
        {aba("candidato", "Candidato")}
      </div>
      {ativas.length === 0 && <p className="text-sm text-gray-500 mt-3">Ainda não há candidaturas nas suas vagas abertas.</p>}
      {ativas.length > 0 && (modo === "vaga"
        ? <CampoBusca key="v" opcoes={opVagas} valor={vaga} escolher={setVaga} placeholder="Digite ou escolha a vaga (ex.: analista)" />
        : <CampoBusca key="c" opcoes={opPessoas} valor={pessoa} escolher={setPessoa} placeholder="Digite parte do nome (ex.: silva)" />)}
      {linhas.length > 0 && (
        <div className="mt-3 divide-y divide-gray-100 max-h-96 overflow-auto">
          {linhas.map((c) => (
            <div key={c.vagaId + "-" + c.usuarioId} className="flex items-center gap-2 py-2 text-sm">
              <div className="flex-1 min-w-0">
                <div className="font-semibold text-text">{modo === "vaga" ? c.nome : c.vaga}</div>
                <div className="text-xs text-gray-500">candidatou-se em {dia(c.candidaturaEm)}</div>
              </div>
              <Acao c={c} />
            </div>
          ))}
        </div>
      )}
    </section>
  );
}

export default function EntrevistasPage() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [dados, setDados] = useState(null);
  const [erro, setErro] = useState("");
  const [aviso, setAviso] = useState("");
  const [pedindo, setPedindo] = useState(null);   // entrevista com o modal "pedir outros horários" aberto
  const [agendando, setAgendando] = useState(null); // empresa: { vagaId, candidato, remarcar }
  const [abaEmp, setAbaEmp] = useState("agenda");   // empresa: "agenda" (calendário + entrevistas) | "chamar"
  const [aulas, setAulas] = useState([]);           // candidato: aulas grátis entram na mesma agenda
  useEffect(() => { if (user?.tipo === 0) minhasAulas().then((a) => setAulas(Array.isArray(a) ? a : (a?.aulas || []))).catch(() => {}); }, [user]);
  const [aberta, setAberta] = useState(null);       // entrevista aberta no modal (clique na agenda)
  const [aulaAberta, setAulaAberta] = useState(null); // candidato: aula aberta no modal
  const abrirCartao = (id) => setAberta(id);
  const caixaModal = React.useRef(null);
  useEffect(() => {
    const caixa = caixaModal.current;
    const topo = caixa && caixa.querySelector("[data-topo-modal]");
    if (!topo || typeof ResizeObserver === "undefined") return undefined;
    const medir = () => caixa.style.setProperty("--topo", `${topo.offsetHeight - 20}px`);
    medir();
    const ro = new ResizeObserver(medir);
    ro.observe(topo);
    return () => ro.disconnect();
  }, [aberta, dados]);
  const carregar = () => minhasEntrevistas().then(setDados).catch((e) => setErro(e.message));
  useEffect(() => {
    if (!user) { navigate("/entrar?redirect=/entrevistas"); return; }
    document.title = "Entrevistas · eaiRH";
    carregar();
  }, [user]); // eslint-disable-line react-hooks/exhaustive-deps
  if (!user) return null;
  const faz = async (fn, ok) => { setErro(""); setAviso(""); try { await fn(); setAviso(ok); carregar(); } catch (e) { setErro(e.message); } };
  const lista = dados?.entrevistas || [];
  // 18/10/2026 (Nelson: "ao clicar no bloco não seria mais legal abrir o modal?"): o mesmo cartão serve à lista e ao modal.
  const cartao = (e, noModal) => {
    const st = STATUS_ENTREVISTA[e.status] || { txt: e.status, cls: "bg-slate-100" };
    return (
              <div key={e.id} className={"bg-white rounded-2xl p-5 text-sm " + (noModal ? "" : "shadow-sm")}>
                {/* 18/10/2026 (Nelson): no modal, o topo (vaga, status, botões) e as abas não rolam com a página */}
                <div data-topo-modal={noModal ? "1" : undefined} className={noModal ? "sticky top-0 z-20 bg-white -mx-5 -mt-5 px-5 pt-5 pb-1 rounded-t-2xl" : ""}>
                {noModal && <button onClick={() => setAberta(null)} className="absolute top-2 right-3 text-gray-400 hover:text-gray-700 text-xl" title="Fechar">×</button>}
                <div className="flex flex-wrap items-center gap-2 pr-6">
                  <b className="text-text">{e.vaga}</b>
                  <span className="text-gray-500">· {dados.ehEmpresa ? e.candidato : e.empresa}</span>
                  <span className={`rounded-full px-2 py-0.5 text-xs font-semibold ${st.cls}`}>{st.txt}</span>
                </div>
                {e.inicio && e.status !== "proposta" && <div className="text-gray-700 mt-1">{quando(e.inicio)} · {e.duracaoMin} min</div>}
                {e.mensagem && <div className="text-gray-500 italic mt-1">“{e.mensagem}”</div>}
                {!dados.ehEmpresa && e.status === "proposta" && (
                  <div className="mt-3 rounded-xl bg-amber-50 border border-amber-200 p-3">
                    <div className="font-semibold text-amber-900">Escolha um horário{e.prazoEscolha && <> até {quando(e.prazoEscolha)}</>}:</div>
                    <div className="flex flex-wrap gap-2 mt-2">
                      {e.horarios.map((h) => {
                        const passou = new Date(h) <= new Date();
                        return (
                          <button key={h} disabled={passou} title={passou ? "Este horário já começou" : "Escolher este horário"}
                            onClick={() => faz(() => escolherHorarioEntrevista(e.id, h), "Entrevista confirmada! O convite foi para o seu e-mail.")}
                            className={`border rounded-lg px-3 py-1.5 font-semibold ${passou ? "bg-gray-100 border-gray-200 text-gray-400 line-through cursor-not-allowed" : "bg-white border-amber-300 hover:bg-amber-100"}`}>{quando(h)}</button>
                        );
                      })}
                    </div>
                    <button onClick={() => { setAberta(null); setPedindo(e); }}
                      className="text-xs text-amber-800 font-semibold mt-2">Nenhum serve? Pedir outros horários</button>
                  </div>
                )}
                {dados.ehEmpresa && e.status === "proposta" && <div className="text-xs text-gray-500 mt-1">Horários propostos: {e.horarios.map(quando).join(" · ")}</div>}
                {dados.ehEmpresa && <SituacaoEntrevista e={e} onMudou={carregar}
                  onRemarcar={() => setAberta(null) || setAgendando({ vagaId: e.vagaId, candidato: { usuarioId: e.candidatoId, nome: e.candidato || "candidato" }, remarcar: e.status === "confirmada" })} />}
                {!dados.ehEmpresa && <div className="flex flex-wrap gap-2 mt-3">
                  {e.link && <a href={e.link} onClick={(ev) => abrirSala(ev, e.link)} className="bg-brand text-white font-bold rounded-lg px-3 py-1.5 text-xs">Entrar na sala</a>}
                  {e.status === "confirmada" && e.podeMexer && (
                    <button onClick={() => { setAberta(null); setPedindo(e); }} className="bg-slate-100 font-semibold rounded-lg px-3 py-1.5 text-xs">Pedir remarcação</button>
                  )}
                  {e.podeMexer && <button onClick={() => window.confirm("Cancelar esta entrevista?") && faz(() => cancelarEntrevista(e.id), "Entrevista cancelada.")} className="text-red-600 text-xs font-semibold">Cancelar</button>}
                </div>}
                </div>
                {noModal && <Preparacao e={e} ehEmpresa={dados.ehEmpresa} />}
              </div>
    );
  };
  const entAberta = aberta && lista.find((x) => x.id === aberta);
  return (
    <div className="min-h-screen bg-background">
      {entAberta && (
        <div className="fixed inset-0 z-[60] bg-black/50 flex items-center justify-center p-4" onClick={() => setAberta(null)}>
          <div ref={caixaModal} className="relative w-full max-w-3xl max-h-[94vh] overflow-y-auto overscroll-contain rounded-2xl shadow-2xl bg-white" onClick={(ev) => ev.stopPropagation()}>
            {cartao(entAberta, true)}
          </div>
        </div>
      )}
      {aulaAberta && (
        <div className="fixed inset-0 z-[60] bg-black/50 flex items-center justify-center p-4" onClick={() => setAulaAberta(null)}>
          <div className="relative w-full max-w-md bg-white rounded-2xl shadow-2xl p-5 text-sm" onClick={(ev) => ev.stopPropagation()}>
            <button onClick={() => setAulaAberta(null)} className="absolute top-2 right-3 text-gray-400 hover:text-gray-700 text-xl" title="Fechar">×</button>
            <div className="font-bold text-text">🎓 {aulaAberta.skill ? `Aula de ${aulaAberta.skill}` : "Aula grátis"}</div>
            <div className="text-gray-600 mt-1">com {aulaAberta.com}</div>
            <div className="text-gray-700 mt-1">{quando(aulaAberta.status === "sugerida" && aulaAberta.sugeridoInicio ? aulaAberta.sugeridoInicio : aulaAberta.inicio)} · {aulaAberta.duracaoMin} min</div>
            <div className="flex flex-wrap gap-2 mt-4">
              {aulaAberta.link && <a href={aulaAberta.link} onClick={(ev) => abrirSala(ev, aulaAberta.link)} className="bg-brand text-white font-bold rounded-lg px-3 py-1.5 text-xs">Entrar na sala</a>}
              <Link to="/capacitacao" className="bg-slate-100 font-semibold rounded-lg px-3 py-1.5 text-xs">Abrir em Aulas grátis (remarcar, cancelar)</Link>
            </div>
          </div>
        </div>
      )}
      <Header />
      {pedindo && <PedirOutros entrevista={pedindo} fechar={() => setPedindo(null)}
        enviar={(texto, sugestoes) => { const id = pedindo.id; setPedindo(null); faz(() => pedirOutrosHorarios(id, texto, sugestoes), "Pedido enviado à empresa."); }} />}
      {agendando && <AgendarEntrevista vagaId={agendando.vagaId} candidato={agendando.candidato} remarcar={agendando.remarcar}
        onFechar={() => setAgendando(null)} onAgendado={() => { setAgendando(null); setAviso("Horários enviados ao candidato."); carregar(); }} />}
      <main className={(dados?.ehEmpresa ? "max-w-5xl" : "max-w-3xl") + " mx-auto px-4 md:px-6 py-8"}>
        <h1 className="text-2xl font-bold text-text">{dados?.ehEmpresa ? "Entrevistas das suas vagas" : "Minhas entrevistas"}</h1>
        <p className="text-sm text-gray-600 mt-1">As entrevistas acontecem na sala de vídeo do eaiRH, direto no navegador. A sala abre 15 minutos antes.</p>
        {erro && <p className="mt-3 rounded-xl bg-red-50 border border-red-200 text-red-700 text-sm px-3 py-2">{erro}</p>}
        {aviso && <p className="mt-3 rounded-xl bg-green-50 border border-green-200 text-green-800 text-sm px-3 py-2">{aviso}</p>}
        {dados?.ehEmpresa && (
          <div className="flex gap-1 mt-5 border-b border-gray-200">
            {[["agenda", "📆 Agenda da semana"], ["chamar", "📅 Chamar para entrevista"], ["simular", "🧪 Simular uma entrevista"]].map(([k, txt]) => (
              <button key={k} onClick={() => setAbaEmp(k)}
                className={"px-4 py-2 text-sm font-semibold rounded-t-lg -mb-px " + (abaEmp === k ? "bg-white border border-gray-200 border-b-white text-primary" : "text-gray-500 hover:text-gray-800")}>{txt}</button>
            ))}
          </div>
        )}
        {dados?.ehEmpresa && abaEmp === "chamar" && <ChamarParaEntrevista entrevistas={lista} abrir={setAgendando} />}
        {/* 🧪 23/10/2026: teste da sala com um colega (piloto) — fora das entrevistas reais e da reputação */}
        {dados?.ehEmpresa && abaEmp === "simular" && <SimularEntrevista />}
        {dados?.ehEmpresa && abaEmp === "agenda" && <AgendaSemana itens={itensDeEntrevistas(lista, (e) => e.candidato, (e) => abrirCartao(e.id))}
          vazio={<>Nenhuma entrevista nesta semana. Use a aba <b>Chamar para entrevista</b> para agendar.</>} />}
        {dados && !dados.ehEmpresa && (lista.length > 0 || aulas.length > 0) && (
          <AgendaSemana itens={[...itensDeEntrevistas(lista, (e) => e.empresa, (e) => abrirCartao(e.id)), ...itensDeAulas(aulas, (a) => setAulaAberta(a))]}
            vazio="Nada marcado nesta semana." />
        )}
        {dados?.ehEmpresa && abaEmp === "agenda" && lista.length > 0 && <h2 className="font-bold text-text mt-8">Todas as entrevistas</h2>}
        {dados && lista.length === 0 && (!dados.ehEmpresa || abaEmp === "agenda") && (
          <p className="mt-6 text-sm text-gray-500">{dados.ehEmpresa
            ? <>Nenhuma entrevista ainda. Use a aba <b>📅 Chamar para entrevista</b>, ou abra uma vaga e use <b>📅 Agendar entrevista</b> na lista de candidaturas.</>
            : <>Nenhuma entrevista ainda. Quando uma empresa quiser entrevistar você pelo eaiRH, o convite aparece aqui. <Link to="/vagas" className="text-primary font-semibold">Ver vagas</Link></>}</p>
        )}
        <div className={"mt-6 space-y-4 " + (dados?.ehEmpresa && abaEmp !== "agenda" ? "hidden" : "")}>
          {lista.map((e) => cartao(e, false))}
        </div>
      </main>
    </div>
  );
}
